import React, { useId } from 'react';

export function CelestialShell({ children, className = '', authenticated = false }) {
  return (
    <div className={`br-page ${authenticated ? 'br-page--authenticated' : ''} ${className}`.trim()}>
      <div className="br-fixed-background" style={{ backgroundImage: "url('/background-stars.png')" }} aria-hidden="true" />
      {children}
    </div>
  );
}

export function BrandLens({ size = 'medium', className = '' }) {
  const id = useId().replace(/:/g, '');
  return (
    <div className={`br-brand-lens br-brand-lens--${size} ${className}`.trim()} aria-hidden="true">
      <svg viewBox="0 0 420 420" role="presentation">
        <defs>
          <radialGradient id={`${id}-body`} cx="36%" cy="28%" r="72%">
            <stop offset="0" stopColor="#fffdf1" stopOpacity=".88" />
            <stop offset=".25" stopColor="#f5dfad" stopOpacity=".38" />
            <stop offset=".62" stopColor="#76d5cd" stopOpacity=".14" />
            <stop offset="1" stopColor="#092a32" stopOpacity=".38" />
          </radialGradient>
          <linearGradient id={`${id}-rim`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#ffffff" stopOpacity=".72" />
            <stop offset=".34" stopColor="#72d8cf" stopOpacity=".19" />
            <stop offset=".68" stopColor="#f5dca5" stopOpacity=".42" />
            <stop offset="1" stopColor="#ffffff" stopOpacity=".08" />
          </linearGradient>
          <filter id={`${id}-glow`} x="-80%" y="-80%" width="260%" height="260%">
            <feGaussianBlur stdDeviation="18" />
          </filter>
        </defs>
        <circle cx="210" cy="210" r="126" fill="#f5deb3" opacity=".12" filter={`url(#${id}-glow)`} />
        <g className="br-brand-lens__orbit br-brand-lens__orbit--one">
          <ellipse cx="210" cy="210" rx="174" ry="155" fill="none" stroke="#f7e5bd" strokeOpacity=".19" strokeWidth="1" strokeDasharray="116 34 25 52" />
        </g>
        <g className="br-brand-lens__orbit br-brand-lens__orbit--two">
          <ellipse cx="210" cy="210" rx="155" ry="174" fill="none" stroke="#78d9d0" strokeOpacity=".12" strokeWidth="1" strokeDasharray="55 44 104 36" />
        </g>
        <circle cx="210" cy="210" r="119" fill={`url(#${id}-body)`} stroke={`url(#${id}-rim)`} strokeWidth="1.7" />
        <path d="M127 188c18-60 69-95 126-92" fill="none" stroke="#fff" strokeOpacity=".36" strokeWidth="3" strokeLinecap="round" />
        <path d="M294 261c-22 42-65 68-113 63" fill="none" stroke="#f5deb3" strokeOpacity=".13" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="168" cy="162" r="34" fill="#fff" opacity=".08" />
      </svg>
    </div>
  );
}

export function SystemFooter() {
  return (
    <footer className="br-system-footer">
      <div className="br-system-footer__content">
        <p>BrightResolve is an artificial intelligence system designed for natural conversation. It is not a person or conscious being.</p>
        <nav aria-label="Legal and support">
          <a href="/terms">Terms</a><a href="/privacy">Privacy</a><a href="/support">Support</a><a href="/contact">Contact</a>
        </nav>
      </div>
    </footer>
  );
}

export function PageHeader({ eyebrow, title, description, aside }) {
  return (
    <header className="br-page-header">
      <div>
        {eyebrow && <p className="br-eyebrow">{eyebrow}</p>}
        <h1 className="br-page-title">{title}</h1>
        {description && <p className="br-page-description">{description}</p>}
      </div>
      {aside && <div className="br-page-header__aside">{aside}</div>}
    </header>
  );
}
